import { useEffect, useRef } from "react";
import { sendWhenEpmsAnalyticsAllows } from "../utils/epmsAnalyticsReady";
import { viewedItemKey } from "../utils/viewedItems";
/**
 * Reports view_item once per item the page opens with. Pass null until the
 * item and its price are known. Only for pages that create a new product:
 * editing a cart line is not a view of something new. Each mount creates a
 * new instance, so this counts once per open of the editor, as the desktop
 * editors do - see App\Service\Analytics\AnalyticsEventScript.
 */
export default function useViewItem(item) {
    const reportedKey = useRef(null);
    const key = item ? viewedItemKey(item) : null;
    useEffect(() => {
        if (key === null || key === reportedKey.current || !item) {
            return;
        }
        return sendWhenEpmsAnalyticsAllows((analytics) => {
            const delivered = analytics.onViewItem(item);
            if (delivered) {
                reportedKey.current = key;
            }
            return delivered;
        });
        // The key stands for the item, which is a new object every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
}
